var rootLinkSearch = "https://apps.omegatheme.com/searchify";
var shopNameSearch = Shopify.shop;
var searchRequest = null;
var resultSuggest = {};
var selectCollection = '';
var settingsSearch;
var moneyFormatSearch;
var window_jQuery;

if (typeof window.checkJSES == 'undefined') {
    window.checkJSES = 1;

    loadJquerySearch(function (jQuery) {
        elasticSearch_init(jQuery);
    })

    function loadJquerySearch(callback){
        if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.9)) {
            getScript({
                source: "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
                callback: () => {
                    jQuery224 = jQuery.noConflict(true);
                    callback(jQuery224);
                }
            });
        } else {
            callback(jQuery);
        }
    }

    async function elasticSearch_init(jQuery){ 
        window_jQuery = jQuery;
        var result =  await omgrfq_checkInstallApp();
        if (result != null && result.enable_app == 1) {
            settingsSearch = result;
            moneyFormatSearch = result.moneyFormat;
            elasticSearchLoadFile();
        }
    }

    function elasticSearchLoadFile(){
        var d = new Date();
        var ver = d.getTime();
        getScript({ source: rootLinkSearch + `/appSuggest.js?v=`+ver,callback: function () {
                ot_elasticSearch();
            }
        })

        getScript({ source: rootLinkSearch + `/appResult.js?v=`+ver,callback: function () {
                elasticSearchResult_init();
            }
        })
    }

    function getScript({ source,  callback  }) {
        var script = document.createElement('script');
        var prior = document.getElementsByTagName('script')[0];
        script.async = 1;

        script.onload = script.onreadystatechange = function (_, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                script.onload = script.onreadystatechange = null;
                script = undefined;

                if (!isAbort) {
                    if (callback) callback();
                }
            }
        };

        script.src = source;
        prior.parentNode.insertBefore(script, prior);
    }

	function omgrfq_checkInstallApp(){
        var $ = window_jQuery;
        var d = new Date();
        var ver = d.getTime();
        return new Promise(resolve => {
            $.getJSON(rootLinkSearch + "/cache/" + shopNameSearch +"/data.json?v="+ver, function( data ) {
                resolve(data);
            })
        })
    }
}

function getCssFormSuggestion(element){
    var body = $('body').width();
    var top = (element.offset().top + element.outerHeight());
    var left = element.offset().left;
    var width = element.outerWidth();
    var right = (body - left - width);

    if (screen.width > 380) {
        if (width < 380 || width > 800) width = 380;
    }

    if (top > 1500) {
        var style = {
            "width": width + 'px',
        }
        $('.ot-content-search').css(style);
        $('.dropdown-arrow').addClass("dropdown-arrow-top");
        $('.dropdown-arrow-right').addClass("dropdown-arrow-right-top");
        $('.dropdown-arrow-left').addClass("dropdown-arrow-left-top");
    }else{
        var style = {
            "top"  :top +'px',
            "width": width + 'px',
        };
        $('.ot-content-search').css(style);
        $('.dropdown-arrow').removeClass("dropdown-arrow-top");
        $('.dropdown-arrow-right').removeClass("dropdown-arrow-right-top");
        $('.dropdown-arrow-left').removeClass("dropdown-arrow-left-top");
    } 
    if (screen.height > 700) {
        $('.dropsearch').css("max-height","600px");
    }else{
        $('.dropsearch').css("max-height","445px");
    }

    if (left < right){
        $('.ot-content-search').css("left", left + 'px');
        $('.dropdown-arrow').css("left", "30px");
    }else{
        $('.ot-content-search').css("right", right + 'px');
        $('.dropdown-arrow').css("right", "30px");
    }

}

function resizeImg(image){
    var listWidthImage = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
    if(image == "")  return "";
    image = image.split(".");
    var extensionImage = image.pop(); 
    var imageOrinal = image.join(".");;
    var listImageBySize = "";
    $.each(listWidthImage, function(index,item){
        listImageBySize += imageOrinal+"_"+item+'x.'+extensionImage+" "+item+"w,";
    })

    var result = `
        data-srcset="`+listImageBySize+`" 
        data-widths='[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]' data-aspectratio='0.7722473604826546'
        data-sizes='auto' 
        sizes='193px' 
        srcset="`+listImageBySize+`"`
    return result ;
}

function formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
  
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";
  
      return dollars + cents;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
}

function shortString(string,limit, charReplace=null){
    if (charReplace == null) charReplace = '...';
    if (typeof string == 'string') {
      var length = string.length;
      if (length > limit) {
          var subString = string.substr(0,(limit-1));
          return subString+charReplace;
      } else{
        return string;
      }
    }else{
      console.log("Please enter string!");
    }
};
